export default __webpack_public_path__ + "static/media/scholarship_icon1.8fb7151e.svg";